/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Club_ThreeInputs */

const en_platform_team_club_three = /** @type {(inputs: Platform_Team_Club_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A morning summary for every coach`)
};

const pl_platform_team_club_three = /** @type {(inputs: Platform_Team_Club_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podsumowanie dnia dla każdego trenera`)
};

/**
* | output |
* | --- |
* | "A morning summary for every coach" |
*
* @param {Platform_Team_Club_ThreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_club_three = /** @type {((inputs?: Platform_Team_Club_ThreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Club_ThreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_club_three(inputs)
	return en_platform_team_club_three(inputs)
});